import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { zIndex } from '../../../../play-core/styles/z-index';
import { Button } from '../ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const buttonHeight = 54;
export const MobileDialogButton = ({
  text,
  onClick
}) => /*#__PURE__*/_jsx(Container, {
  children: /*#__PURE__*/_jsx(StickyContainer, {
    children: /*#__PURE__*/_jsx(StyledButton, {
      type: "text",
      text: text,
      onClick: onClick,
      expand: true
    })
  })
});
const Container = styled.footer.withConfig({
  displayName: "MobileDialogButton__Container",
  componentId: "sc-1x0drsl-0"
})(["position:relative;height:", "px;background-color:", ";"], buttonHeight + 8, Colors.GREY_1a1a1a);
const StickyContainer = styled.div.withConfig({
  displayName: "MobileDialogButton__StickyContainer",
  componentId: "sc-1x0drsl-1"
})(["position:fixed;right:0;left:0;bottom:0;z-index:", ";display:flex;justify-content:end;width:100%;height:", "px;margin-top:8px;"], zIndex.popup, buttonHeight);
const StyledButton = styled(Button).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "MobileDialogButton__StyledButton",
  componentId: "sc-1x0drsl-2"
})(["height:", "px;color:", ";background-color:", ";border-radius:0;&:active{background-color:", ";}"], buttonHeight, Colors.GREY_1a1a1a, Colors.GREY_e1e1e1, Colors.GREY_d2d2d2);